import React, { PureComponent } from 'react';
import RegisterForm from './components/RegisterForm';

export default class Register extends PureComponent {

  render () {
    //const { msg } = this.props.location.state

    return (
      <div className='account'>
        <div className='account__wrapper'>
          <div className='account__card' style={{
            maxHeight: '940px'
          }}>
            <RegisterForm onSubmit />
            <div className='account__have-account'>
              <p style={{ color: 'white' }}>{''}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/register/Register.js